import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { wrapDispatch } from "../wrapDispatch";

// export type UserData = {
//   fullName: string;
//   email: string;
//   phoneNo: string;
//   password: string;
//   profileImage: string | File | null;
// };

export interface matchStats {
  totalGames: number;
  wins: number;
  losses: number;
  draws: number;
}

export interface coins {
  balance: number;
  locked: number;
  lifetimeEarned: number;
  lifetimeSpent: number;
}

export interface location {
  type: string;
  coordinates: [number, number];
}
export interface UserData {
  _id?: string;
  location?: location;
  status?: string;
  name?: string;
  blockedByAdmin?: boolean;
  email?: string;
  password?: string;
  google_id?: string;
  createdAt?: string;
  updatedAt?: string;
  access_token?: string;
  profilePicture?: string;
  allowedEntryFees?: string;
  matchStats?: matchStats;
  coins?: coins;
  level?: number;
}

export type InitialState = {
  userData: UserData;
  isSoundOn: boolean;
  isMusicOn: boolean;
  isPlayMusicOn: boolean;
  touchSound: boolean;
  isMethodRegister: boolean;
  playGame: boolean;
};

const initialState: InitialState = {
  userData: {},
  isSoundOn: true,
  isMusicOn: true,
  isPlayMusicOn: true,
  touchSound: false, // Changed to false: Avoids initial false-positive trigger
  isMethodRegister: true,
  playGame: false,
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    storeUser: (state, action: PayloadAction<UserData>) => {
      state.userData = action.payload;
    },
    updateUserField: (
      state,
      action: PayloadAction<{
        key: keyof UserData;
        value: UserData[keyof UserData];
      }>
    ) => {
      const { key, value } = action.payload;
      state.userData[key] = value as never;
    },

    setSoundPreference: (state, action: PayloadAction<boolean>) => {
      state.isSoundOn = action.payload;
    },
    setMusicPreference: (state, action: PayloadAction<boolean>) => {
      state.isMusicOn = action.payload;
    },
    setPlayMusicPreference: (state, action: PayloadAction<boolean>) => {
      state.isPlayMusicOn = action.payload;
    },
    setPlayGame: (state, action: PayloadAction<boolean>) => {
      state.playGame = action.payload;
    },
    setTouchSound: (state, action: PayloadAction<boolean>) => {
      state.touchSound = action.payload; // New setter: Use to set true on tap, false after play
    },
    // Removed toggleTouchSound: Toggle was causing double-tap issue (initial true + check on updated value)
    setisMethodRegister: (s, a) => {
      s.isMethodRegister = a.payload;
    },
    logoutUser: (s) => {
      s.userData = {};
      // s.isSoundOn = true;
      // s.touchSound = false; // Reset on logout
    },
  },
});

export const userReducer = userSlice.reducer;
export const userAction = wrapDispatch(userSlice.actions);

export type UserDataKeys = keyof UserData;
